import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate } from "@angular/router";
import { SubscriptionService } from "../service/subscription.service";
import { ThemingService } from "../service/theme/theming.service";

@Injectable({
    providedIn: "root"
})
export class PublicGuard implements CanActivate {
    constructor(private subscription: SubscriptionService, private theme: ThemingService) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const subscriptionId: string = route.queryParams.subscriptionId || route.queryParams.sid;

        if (subscriptionId) {
            this.subscription.setCurrentSubscriptionId(subscriptionId);

            this.theme.setCached(subscriptionId);

            return true;
        }

        return false;
    }
}
